// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-arrow {\n  margin-right: 30px;\n  cursor: pointer;\n  font-size: 20px;\n}\n.vxe-container .vxe-modal--content {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
